import { Branch, UtilsService } from "../gen/clients/llts";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useUserSession } from "./useUserSession";
import { useCurrentUserBranch } from "./useCurrentUserBranch";

interface PathParams {
  lltsBranchId?: string;
}

/**
 * Custom hook to fetch the LLTS branch for the current page.
 */
export function useLltsBranch(): Branch | undefined {
  const { lltsBranchId } = useParams<PathParams>();
  const { username } = useUserSession();
  const { data: lltsBranch } = useQuery(["getLltsBranch", lltsBranchId], {
    enabled: !!lltsBranchId && !username,
    queryFn: () => UtilsService.getBranch({ branchId: lltsBranchId || "" })
  });
  const { data: userBranch } = useCurrentUserBranch();
  return userBranch || lltsBranch || undefined;
}
